<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link
            to="/"
            class="d-flex align-center"
          >
            <a
              aria-label="Логотип khimkibc.events"
              class="logo"
              tabindex="0"
              href="/"
            >
              <v-img
                width="170"
                :src="require('@/assets/images/khimki_bc_group.svg')"
              ></v-img></a>
          </router-link>
        </v-card-title>

        <!-- title -->

        <!-- login form -->
        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-text-field
              v-model="phone"
              v-mask="phoneMask"
              outlined
              label=""
              prefix="+7"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              hide-details
              @input="onPhoneInput"
            ></v-text-field>

            <div
              class="mb-3"
              style="font-size: 12px; padding: 4px 12px 0;"
              :style="{ color: isPhoneValid ? '#9e9e9e' : '#ff5252' }"
            >
              {{ isPhoneValid ? 'Укажите номер Вашего мобильного телефона' : 'Неправильный формат номера телефона' }}
            </div>

            <v-text-field
              v-model="password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="Пароль"
              placeholder="············"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              hide-details
              @click:append="isPasswordVisible = !isPasswordVisible"
            ></v-text-field>

            <div
              v-if="error_message"
              style="margin-top: 10px; font-size: 14px; color: #fff; padding: 20px"
              class="error"
            >
              {{ error_message }}
            </div>

            <v-btn
              type="submit"
              block
              color="primary"
              class="mt-6"
            >
              Вход
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
    <my-loader :loader="loader"></my-loader>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import MyLoader from '@/components/MyLoader.vue'
import {
  PHONE_MASK,
  formatPhoneForApi,
  isValidPhoneDigits,
  normalizePhoneDigits,
} from '@/utils/phone'
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from 'vue'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  components: { MyLoader },
  data() {
    return {
      isPasswordVisible: ref(false),
      phone: ref(''),
      password: ref(''),
      error_message: null,
      loader: false,
      isPhoneValid: true,
      phoneMask: PHONE_MASK,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
  methods: {
    ...mapActions(['LogIn']),
    onPhoneInput() {
      if (!this.isPhoneValid) {
        this.isPhoneValid = true
      }
    },
    async submit() {
      const digits = normalizePhoneDigits(this.phone)

      if (!isValidPhoneDigits(digits)) {
        this.isPhoneValid = false
        return
      }

      this.isPhoneValid = true

      const user = {
        phone: formatPhoneForApi(digits),
        password: this.password,
      }
      try {
        this.$set(this, 'loader', true)
        await this.LogIn(user)
        this.$router.push('/dashboard')
      } catch (error) {
        this.error_message = 'Неправильная пара логин/пароль'
        this.$set(this, 'loader', false)
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
